import { StrictMode, startTransition } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { captureException } from '@sentry/react';
import { initialiseAxiosClient } from '@shape-construction/api/client';
import { initialiseGlobalAxiosClient } from '@shape-construction/api/global-client';
import { axiosInstance, globalAxiosInstance } from 'app/axios';
import { setupInterceptors } from 'app/axios-interceptor';
import { ensureMsalIsInitialized } from 'app/msalAuthConfig';
import { HydratedRouter } from 'react-router/dom';
import './index.css';
import { initializeConnectivityEvaluator } from 'app/lib/connectivity';
import { prefetchAssets } from 'libs/prefetch-assets';
import { enableWebReporting } from 'libs/reporting';
import { registerSW } from 'virtual:pwa-register';
enableWebReporting();
initialiseAxiosClient(axiosInstance);
initialiseGlobalAxiosClient(globalAxiosInstance);
setupInterceptors(axiosInstance);
setupInterceptors(globalAxiosInstance);
void ensureMsalIsInitialized();

// The service worker skips waiting and claims clients itself, so updates apply
// automatically on the next page load — no update prompt (SE-2380).
registerSW({
  onRegisterError: error => captureException(error)
});
startTransition(() => {
  hydrateRoot(document, <StrictMode>
      <HydratedRouter />
    </StrictMode>);
});
prefetchAssets();
initializeConnectivityEvaluator();